@if (loadingService.loadingRequests.length > 0) {
  <apc-loading-screen></apc-loading-screen>
}
@if (loadingService?.playGame) {
  <njo-pacman></njo-pacman>
}
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<app-modal-error></app-modal-error>
<router-outlet></router-outlet>
<div id="blanket" class="d-none"></div>
<njo-fireworks></njo-fireworks>
